BaseManager = require 'BaseManager'
loadingManager = require 'loadingManager'
each = require 'async-each'
log = require 'loglevel'

###############################################

class ImageManager extends BaseManager

  allNamespaces: []

  # -------------------------------------------

  loadImage: (url, cb) ->

    img = new Image()
    img.onload = =>
      cb img
    img.src = url + '?v=' + window.__version;

  # -------------------------------------------

  loadAsset: (url, callback) ->
    @loadAssets [url], callback

  # -------------------------------------------

  loadAssets: (urls, callback) ->

    unless @loader?
      @loader = new PIXI.loaders.Loader()

    urls = urls.noDupe()

    tmp = []
    for url in urls
      unless @loader.resources[url]?
        tmp.push url
        extension = url.split('.').pop()
        @allNamespaces.push url if extension is 'json'

    return callback() if not tmp.length

    @loader.defaultQueryString = 'v=' + window.__version;
    @loader.add(tmp)

    @loader.on 'progress', (progress ,resource) =>
      loadingManager.set progress.progress/100

    @loader.on 'error', (err) =>
      console.error(err)
      callback err

    @loader.once 'complete', (result) =>
      callback result

    @loader.load()

  # -------------------------------------------

  makeTexturesFromName: (name) ->

    textures = []
    for namespace in @allNamespaces
      newTextures = @makeTexturesFromNamespace namespace, name
      textures = textures.concat newTextures

    textures.sortByKey('__name')

    textures

  # -------------------------------------------

  makeTexturesFromNamespace: (namespace,name) ->

    textures = @loader.resources[namespace].textures
    re = new RegExp(name,"g")

    tmp = []

    for key, value of textures

      if key.match(re)
        value.__name = key
        tmp.push value
    tmp

  # -------------------------------------------

  getSpriteSheetImageNames: ->

    tmp = []
    for resourceName in @allNamespaces
      tmp.push resourceName + '_image'
    tmp

  # -------------------------------------------

  exists: (key) ->
    @loader.resources[key]?


module.exports = ImageManager.getInstance()


// WEBPACK FOOTER //
// ./coffee/manager/image-manager.coffee